import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton } from '@adsk/alloy-react-menu';
import { useLocale } from '@adsk/alloy-react-helpers';
import ProductsMenu from './ProductsMenu';

const InProductSettings = ({ adminAccessProducts }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <DropdownButton
      size={DropdownButton.SIZES.MEDIUM}
      variant={DropdownButton.VARIANTS.TERTIARY}
      renderContent={(props) => <ProductsMenu {...props} />}
      options={adminAccessProducts}
      style={{ marginLeft: '20px' }}
      menuStyle={{ minWidth: '250px' }}
      placement={DropdownButton.PLACEMENTS.BOTTOM_START}
    >
      {T.translate('PROJECT_PRODUCT_SETTINGS')}
    </DropdownButton>
  );
};

InProductSettings.propTypes = {
  adminAccessProducts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      icon: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

InProductSettings.defaultProps = {
  adminAccessProducts: [],
};

export default InProductSettings;
